import { CoreModule } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgModule } from '@angular/core';
import { NgbCollapseModule, NgbDatepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { AssetEventComponent } from './components/asset-event.component';
import { AssetEventsModalComponent } from './components/asset-events-modal/asset-events-modal.component';
import { AssetEventRoutingModule } from './asset-event-routing.module';

@NgModule({
  declarations: [AssetEventComponent, AssetEventsModalComponent],
  imports: [
    AssetEventRoutingModule,
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgxValidateCoreModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbDropdownModule,
  ],
  exports: [AssetEventComponent, AssetEventsModalComponent]
})
export class AssetEventModule {}

export function loadAssetEventModuleAsChild() {
  return Promise.resolve(AssetEventModule);
}
